import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import ReturnListItemTile from "@/components/Returns/v1/ReturnListItem/ReturnListItemTile"
import styles from "./returnListItem.module.scss"
import { getTranslations } from "@/components/Returns/v1/localization"
import { useTranslation } from "next-i18next"

const ReturnListItem = ({
  isReturns = false,
  curstep = false,
  data = {},
  brandName = "",
  currencySign = "",
  status = "",
  skuId = "",
  quantityVal = "",
  getItems = () => {},
  reasonList = [],
  handleReturnData = () => {},
  returnData = "",
  totalQuantity = "",
  isReturnConfirmed=false,
  returnedItems={},
  errorMsg="",
  setErrorMsg =() =>{}
}) => {
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)

  const shipItem =
    data?.item?.length > 0 ? data?.item?.find(item => item.sku === skuId) : {}

  return (
    <div className={styles.returnListItem}>
      <div className="return-listitem">
        {!isReturns ? (
          <h3 className="return-listitem__title">{staticText.returnedItems}</h3>
        ) : null}
        <div className="return-listitem__card">
          {Object.keys(shipItem)?.length > 0 ? (
            <div
              key={shipItem?.sku}
              className={`return-listitem__flex return-listitem-carditems ${
                status === "complete" ? "return-listitem__edit" : ""
              }`}
            >
              <ReturnListItemTile
                isReturns={isReturns}
                curstep={curstep}
                item={shipItem}
                brandName={brandName}
                currencySign={currencySign}
                staticText={staticText}
                quantityVal={quantityVal}
                returnList={reasonList}
                getItems={getItems}
                handleReturnData={handleReturnData}
                returnVal={returnData}
                totalQuantity={totalQuantity}
                isReturnConfirmed={isReturnConfirmed}
                returnedItems={returnedItems}
                errorMsg={errorMsg}
                setErrorMsg={setErrorMsg}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default ReturnListItem
